import { IoClose } from "react-icons/io5";
import { useLocation } from "react-router-dom";
import { consultationJSONAtom } from "../../new_consultation/constants/_constant";
import { useAtom } from "jotai";

const AddConsultation = ({
  setIsSuggestion,
  customfields,
  handleDeleteData,
  handleSearch,
  searchInput,
  selectedData,
  handleAddData,
  adviceInput,
  addictions,
  allergies,
  patientHistory,
  billingServices,
  setBillingServices,
}) => {
  const [consultationJSON] = useAtom(consultationJSONAtom);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const step = searchParams.get("step");
  const lowercaseLabel = consultationJSON[step]?.label
    ?.replace(/\s+/g, "")
    ?.toLowerCase();

  // //("Billing", billingServices);

  return (
    <div className="mt-[90px]">
      <div className="w-full px-4">
        <div
          className={`w-full ${
            consultationJSON[step]?.key === "adviceDirection"
              ? "h-[113px]"
              : "h-[53px]"
          } border rounded`}
        >
          {consultationJSON[step]?.key !== "adviceDirection" && (
            <input
              className="w-full h-full outline-none pl-4 bg-[#F6F6F6]"
              placeholder={`Search ${consultationJSON[step]?.label}`}
              type="text"
              onClick={() => setIsSuggestion(true)}
            />
          )}
          {consultationJSON[step]?.key === "adviceDirection" && (
            <textarea
              className="w-full h-full outline-none pl-3 pt-3 bg-[#F6F6F6]"
              placeholder={`Search ${consultationJSON[step]?.label}`}
              onChange={handleSearch}
              value={adviceInput?.description}
            />
          )}
        </div>

        {searchInput?.length > 0 && selectedData?.length > 0 && (
          <div className="px-4 border-b pb-1">
            {selectedData?.map((ele) => {
              // console.log(ele);
              return (
                <div
                  key={ele?.id}
                  className="h-[53px] flex justify-between items-center"
                  onClick={() => handleAddData(ele)}
                >
                  {ele?.description}
                </div>
              );
            })}
          </div>
        )}

        {/* {searchInput?.length === 0 && (
          <div className="px-4 border-b pb-1">
            {selectedData?.map((ele) => {
              console.log(ele);
              return (
                <div
                  key={ele?.id}
                  className="h-[53px] flex justify-between items-center"
                  onClick={() => handleAddData(ele)}
                >
                  ADD {ele?.description}
                </div>
              );
            })}
          </div>
        )} */}
        <div className="mt-4 px-4">
          {customfields
            ?.filter((item) =>
              // item?.step == step ||
              item?.tag_type?.includes(consultationJSON[step]?.tagId)
            ) // Filter based on the current step
            .map((item) => (
              <div
                key={item?.id}
                className="h-[53px] flex justify-between items-center"
              >
                <span className="text-[#393939] text-sm">{item?.name}</span>
                <span>
                  <IoClose
                    size={22}
                    color="#393939"
                    onClick={() => handleDeleteData(item?.id)}
                  />
                </span>
              </div>
            ))}

          {lowercaseLabel === "patienthistory" &&
            patientHistory?.map((item) => (
              <div
                key={item?.id}
                className="h-[53px] flex justify-between items-center"
              >
                <span className="text-[#393939] text-sm">{item?.name}</span>
                <span>
                  <IoClose
                    size={22}
                    color="#393939"
                    onClick={() => handleDeleteData(item?.id)}
                  />
                </span>
              </div>
            ))}

          {lowercaseLabel === "allergy" &&
            allergies?.map((item) => (
              <div
                key={item?.id}
                className="h-[53px] flex justify-between items-center"
              >
                <span className="text-[#393939] text-sm">{item?.name}</span>
                <span>
                  <IoClose
                    size={22}
                    color="#393939"
                    onClick={() => handleDeleteData(item?.id)}
                  />
                </span>
              </div>
            ))}

          {lowercaseLabel === "addictions" &&
            addictions?.map((item) => (
              <div
                key={item?.id}
                className="h-[53px] flex justify-between items-center"
              >
                <span className="text-[#393939] text-sm">{item?.name}</span>
                <span>
                  <IoClose
                    size={22}
                    color="#393939"
                    onClick={() => handleDeleteData(item?.id)}
                  />
                </span>
              </div>
            ))}

          {lowercaseLabel === "billing" &&
            billingServices?.map((item) => (
              <div
                key={item?.id}
                className="h-[53px] flex justify-between items-center"
              >
                <span className="text-[#393939] text-sm">
                  {item?.description}
                </span>
                <span>
                  <IoClose
                    size={22}
                    color="#393939"
                    onClick={() => handleDeleteData(item?.id)}
                  />
                </span>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default AddConsultation;
